import register from "preact-custom-element";
import LemonSliceWidget from "./LemonSliceWidget";

const customAttributes = ["agent-id", "show-minimize-button"] as string[];

export function registerWidget(tagName = "lemon-slice-widget") {
  register(LemonSliceWidget, tagName, customAttributes as any, {
    shadow: true,
    mode: "open",
  });
}

registerWidget();
